export default __webpack_public_path__ + "static/media/KG.110498bd.svg";